module.exports = __webpack_public_path__ + "img/banner4.f2dc34e3.jpg";